import React from 'react';
import { Link } from 'react-router-dom';
import type { Lang } from '../types/funnel';
import { business, ownershipLine } from '../data/business';
import { LegalLinks } from './legal/LegalLinks';
const copy = {
  en: {
    scope: 'Moves in Tampa, Orlando, Ocala, Sarasota and approved Florida routes.',
    staff: 'Staff console',
    contact: 'Contact'
  },
  es: {
    scope: 'Mudanzas en Tampa, Orlando, Ocala, Sarasota y rutas aprobadas en Florida.',
    staff: 'Consola del equipo',
    contact: 'Contacto'
  }
};
export function SiteFooter({
  lang,
  showStaff = true
}: {
  lang: Lang;
  showStaff?: boolean;
}) {
  const c = copy[lang];
  return <footer className="border-t border-ink-200 bg-paper" data-id="element-1112" data-mp="33jgdj0z9g1gj">
      <div className="mx-auto grid max-w-6xl gap-4 px-4 py-8 text-sm text-ink-600 sm:px-6 md:grid-cols-[1fr_auto] md:items-end" data-id="element-1113" data-mp="2yjtzipblyh6o">
        <div className="space-y-2" data-id="element-1114" data-mp="11q9242mrq3zx">
          <p className="font-semibold text-ink" data-id="element-1115" data-mp="11p7nxpagh1dz">{ownershipLine[lang]}</p>
          <p data-id="element-1116" data-mp="wtikvbz892cx">{c.scope}</p>
          <p data-id="element-1117" data-mp="wq4hq1iqop4f">
            {c.contact}:{' '}
            <a href={`mailto:${business.email}`} className="underline underline-offset-4 hover:text-ink" data-id="element-1118" data-mp="15qbz88pnn5db">
              {business.email}
            </a>
            {' · '}
            <a href={business.phoneHref} className="underline underline-offset-4 hover:text-ink" data-id="element-1119" data-mp="vsp90q2wnre1">
              {business.phoneDisplay}
            </a>
          </p>
          <LegalLinks lang={lang} className="text-ink-700" data-id="element-1120" data-mp="10sag5ns8b61u" />
          <p className="text-ink-500" data-id="element-1121" data-mp="1oh36n4q30lp2">© 2026 {business.legalName}</p>
        </div>
        {showStaff && <Link to="/admin" className="font-medium text-ink-500 underline underline-offset-4 hover:text-ink" data-id="element-1122" data-mp="1tfegvgkagy7t">
            {c.staff}
          </Link>}
      </div>
    </footer>;
}